export default {
    intro: '뜻을 보고 알맞은 단어를 골라보세요!',
    th: {
        order: '번호',
        meaning: '문제',
        answer: '정답',
        wrong: '오답',
        wrongChoices: '오답선지',
        correctRate: '정답률',
    },
    manySelectedWrongAnswer: '가장 많이 선택한 오답',
    teacher: {
        setting: {
            addQuestion: '문항 추가하기',
            searchCount: '검색 결과 {count}개',
            defaultBadge: '기본',
            otherCount: '외 {count}개',
            waitHeader: '등록 대기 어휘 ({count})',
            clearAll: '모두 비우기',
            registerCount: '활동에 {count}개 등록',
            sameWordBadge: '표제어 동일',
            emptyMeaningBadge: '뜻 없음',
            autoExtract: '자동 추출',
            delete: '삭제',
            close: '닫기',
        },
        modal: {
            clearConfirm: {
                title: '대기 어휘를 모두 비울까요?',
                message: '등록 대기 중인 어휘가 모두 삭제됩니다. 계속하시겠습니까?',
            },
            closeConfirm: {
                title: '입력한 문항을 삭제할까요?',
                message: '닫으면 대기열의 어휘가 모두 사라집니다. 계속하시겠습니까?',
            },
            questionDelete: {
                title: '문항을 삭제할까요?',
                // {word}: 삭제 대상 문항의 정답(표제어). 활동에서 영구 제거됨을 안내.
                message: "'{word}' 문항이 활동에서 삭제됩니다. 계속하시겠습니까?",
            },
            waitItemDelete: {
                title: '대기 어휘를 삭제할까요?',
                // {word}: 삭제 대상 대기 어휘(정답 단어). 대기열에서만 제거되며 활동에는 영향 없음을 안내.
                message: "'{word}'을(를) 대기열에서 삭제합니다. 계속하시겠습니까?",
            },
            // {count}: BE가 사전 중복으로 건너뛴 어휘 수
            duplicateNotice: '이미 등록된 어휘 {count}개는 추가되지 않았습니다.',
            // {count}: 뜻이 없어 등록 불가로 건너뛴 어휘 수
            skippedNotice: '뜻이 비어 있어 {count}개 어휘가 등록되지 않았습니다.',
            // 혼합(뜻없는 어휘 + 뜻있는 어휘) 등록 시 확인 모달
            mixedEmptyConfirm: {
                title: '등록할까요?',
                // {empty}: 뜻 비어 등록 불가 개수
                line1: '뜻이 비어 있는 어휘 {empty}개는 추가되지 않습니다.',
                // {valid}: 실제 등록될 개수
                line2: '나머지 {valid}개만 활동에 등록할까요?',
            },
            // 뜻없는 어휘만 있을 때 등록 불가 안내
            onlyEmptyNotice: {
                title: '등록할 수 없습니다',
                message: '등록할 수 있는 어휘가 없어요. 뜻이 비어 있는 어휘만 남아 있습니다.',
            },
            registerFailed: '등록에 실패했습니다.',
        },
    },
};
